export function createSafeObject<T extends object>(obj: T): T {
  return new Proxy(obj, {
    get(_, prop) {
      /* The property is a function or symbol, return it directly */
      if (typeof prop === 'symbol' || typeof obj[prop] === 'function') {
        return obj[prop];
      }

      /* The property exists and is an object, wrap it with a Proxy */
      if (obj[prop] && typeof obj[prop] === 'object') {
        return createSafeObject(obj[prop]);
      }

      /* The property exists and has a primitive type */
      if (prop in obj) {
        return obj[prop] !== undefined ? obj[prop] : createSafeObject({});
      }

      /* Otherwise, return a new Proxy for undefined or non-object properties */
      return createSafeObject({});
    },
  });
}
